import { IconName, KebabMenuOption } from '@focaldata/cin-ui-components'
import { useState } from 'react'
import { isMultilangPocEnabled } from '../../../../constants/featureFlags'
import useDownloadSurveyDoc from '../../../../hooks/useDownloadSurveyDoc'
import ExportByLanguageDialog from './ExportByLanguageDialog'

/**
 * The survey-export items and their dialog, shared by every kebab that offers
 * them so the labels, icons and behaviour stay identical. Each surface renders
 * its own KebabMenu: the questionnaire subheader needs an offset and a muted
 * icon, the results bars use the design-system default.
 *
 * Must be called under a resolvable surveyId (route param or SurveyIdContext) —
 * the export hooks read one.
 */
export const useSurveyExportMenu = (
  defaultLanguage?: string
): {
  exportOptions: KebabMenuOption[]
  exportDialog: JSX.Element | null
} => {
  const { exportSurvey } = useDownloadSurveyDoc()
  const [byLanguageOpen, setByLanguageOpen] = useState(false)

  const exportOptions: KebabMenuOption[] = [
    {
      id: 0,
      textItem: 'Export survey (.docx)',
      onClickItem: () => exportSurvey(),
      iconName: IconName.Export
    }
  ]

  if (isMultilangPocEnabled()) {
    exportOptions.push({
      id: 2,
      textItem: 'Export by language',
      onClickItem: () => setByLanguageOpen(true),
      iconName: IconName.Language
    })
  }

  return {
    exportOptions,
    exportDialog: isMultilangPocEnabled() ? (
      <ExportByLanguageDialog
        open={byLanguageOpen}
        onClose={() => setByLanguageOpen(false)}
        defaultLanguage={defaultLanguage}
      />
    ) : null
  }
}
